module.exports = __webpack_public_path__ + "img/icon_suc_blue.a8d9a629.svg";